export const layoutStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const sectionHeaderStyles = {
  color: ({ palette }) => palette.text.secondary,
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

export const signerListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
};

export const disclaimerStyles = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '10px',
  padding: '11px 14px',
  borderRadius: '8px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.action.hover,
};

export const disclaimerIconStyles = {
  display: 'flex',
  flexShrink: 0,
  marginTop: '1px',
  color: ({ palette }) => palette.text.secondary,
};

export const disclaimerTextStyles = {
  color: ({ palette }) => palette.text.secondary,
};

export const cardsRowStyles = {
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
  gap: '16px',
  '@media (max-width: 900px)': {
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
};
